import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  clickedItem(event) {
    event.preventDefault();
    var letter = event.target.innerHTML;
    var start = this.inputTarget.selectionStart;
    var end = this.inputTarget.selectionEnd;

    if (start == 0) {
      var prequel = '';
    }
    else {
      var prequel = this.inputTarget.value.slice(0, start);
    }

    if (end == this.inputTarget.value.length) {
      var sequel = '';
    }
    else {
      var sequel = this.inputTarget.value.slice(end);
    }

    var result = prequel.concat(letter).concat(sequel);
    var newCursorLocation = (end + letter.length);

    this.inputTarget.value = result;
    this.inputTarget.selectionStart = newCursorLocation;
    this.inputTarget.selectionEnd = newCursorLocation;
    this.inputTarget.focus();
  }
}
